import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";
import AdminMainLayout from "../../components/layout/AdminMainLayout";
import PowerBiReport from "../../components/powerBiReport/PowerBiReport";

const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

const ToolReportDashboardPage = () => {

  return (
    <>
      <AuthenticatedTemplate>
        <div className="h-[var(--app-height)] overflow-hidden" 
    //   className="bg-[#bb1ccc]/5"
      >
          <Box className="flex h-full">
            {/* Sidebar */}
            <AdminMainLayout />

            {/* Main content */}
            <Box
              component="main"
              className="flex-1 bg-white px-6 py-4 overflow-hidden"
            >
              <DrawerHeader />
              {/* Add more content here as needed */}
 <div  className="bg-[#bb1ccc]/5" style={{
        borderRadius: 8,
        padding: 32,
        // margin: "84px 40px 100px 40px",
        minHeight: "calc(100vh - 124px)",
                boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}>
              <PowerBiReport />

 </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default ToolReportDashboardPage;
